module.exports = __webpack_public_path__ + "img/Rustman.c9d045a4.jpg";